<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <SpecieForm @submit-requested="submitRequested"></SpecieForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import SpecieForm from './SpecieForm.vue'

  export default {
  components: { SpecieForm },
  methods: {
    ...mapActions('species', ['postSpecie']),
    submitRequested (input) {
      this.postSpecie(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 